import React, { useContext, useRef } from 'react';
import T, { t } from '../../../../common/components/T';
// import SingleNews from '../../../news/components/SingleNews/SingleNews';
import { navigateV2 } from '../../../../common/utils/router';
import uikit from '../../../../project/uikit/uikit.module.scss';
import css from './OfficeNews.module.scss';
import classnames from 'classnames';
import Plug from '../../../../widgets/plug/Plug/Plug';
import { LangContext } from '../../../../common/decorators/Language';
import no_news from '../../../../public/src/img/plugs/no_news.svg';
import NewsComponent from './components/NewsComponent/NewsComponent';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import Slider from 'react-slick';
import { svgSprite } from '../../../../hybrid/wrappers';

const OfficeNews = ({ response }) => {
    const { data } = response;
    const { translation } = useContext(LangContext) || {};
    const mobile = useWindowDimensions() < 768;
    const sliderRef = useRef();
    const sliderSettings = {
        dots: false,
        arrows: false,
        ref: sliderRef
    };
    if (!data?.length) return null;
    return !data?.length ? (
        <div className={css.plugWrapper}>
            <Plug
                plugImg={no_news}
                plugTitle={t('officeNews_stat-plugTitle', 'Новости компании', '/office', translation)}
                plugDescription={t(
                    'officeNews_stat-plugDescription',
                    'Вы сможете просмотреть актуальные новости, как только они будут опубликованы',
                    '/office',
                    translation
                )}
            />
        </div>
    ) : (
        <>
            <div className={`custom-scroll4 ${css.newsGrid}`}>
                {!data?.length ? (
                    <div style={{ margin: '0' }} className={classnames(css.newsQuestion)}>
                        <T textName='newsPage' defaultStr='Пока нет новостей' page='/office' />
                    </div>
                ) : (
                    <div className={css.newsTitleWrapper}>
                        <p className={css.newsTitle}>
                            <T textName='company-news' defaultStr='Новости компании' page='/office' />
                        </p>
                        {mobile ? (
                            <div className={css.newsTitleArrows}>
                                <div
                                    onClick={() => sliderRef.current.slickPrev()}
                                    className={classnames('circleButton', css.newsTitleArrow)}
                                >
                                    {svgSprite('angle-left')}
                                </div>
                                <div
                                    onClick={() => sliderRef.current.slickNext()}
                                    className={classnames('circleButton', css.newsTitleArrow)}
                                >
                                    {svgSprite('angle-right')}
                                </div>
                            </div>
                        ) : null}
                    </div>
                )}
                {mobile ? (
                    <Slider {...sliderSettings}>
                        {data?.map((el) => (
                            <NewsComponent key={el.id} data={el} />
                        ))}
                    </Slider>
                ) : (
                    data?.map((el) => <NewsComponent key={el.id} data={el} />)
                )}
            </div>
            <div className={classnames(css.row)}>
                <div className={classnames(css.fullWidth)}>
                    {
                        <div className={classnames(uikit.flexRow, uikit.justifyContentCenter, uikit.alignItemsCenter)}>
                            <div
                                onClick={() => navigateV2('/news')}
                                className={classnames(css.buttonOutLine, css.widgetsButton, css.newsMore, 'grow')}
                            >
                                {/*{svgSprite('newspaper-alt', {*/} {/* className: css.newsPaperSvg,*/} {/*})}*/}
                                <p className={classnames(css.widgetsButtonText, css.newsMoreText)}>
                                    <T textName='to_all_news' defaultStr='Ко всем новостям' page='/office' />
                                </p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    );
};
export default OfficeNews;
